import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchPosts = createAsyncThunk(
  "posts/fetchPosts",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${apiUrl}/trade/getAllTrades`);
      if (userId !== 0) {
        return res.data.filter((post) => post.user_id !== userId);
      } else {
        return res.data;
      }
    } catch (err) {
      return rejectWithValue("Failed to fetch posts.");
    }
  }
);

export const makePurchase = createAsyncThunk(
  "posts/makePurchase",
  async ({ purchaseData, buyerEmail, userId }, { rejectWithValue }) => {
    const finalAmount =
      purchaseData.amountBuy * 100 * purchaseData.rate * 1.029 + 0.3;
    try {
      const res = await axios.get(
        `${apiUrl}/trade/accept?email=${buyerEmail}&tradeId=${purchaseData.postId}&cardId=${purchaseData.selectedCard.id}&bankAccountId=${purchaseData.selectedAccount.bankAccountId}&userId=${userId}&finalAmount=${finalAmount}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue("Network error during purchase.");
    }
  }
);
